import React from 'react';
import { IconProps } from '../types';
const MinecraftPinkPetals: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="13" y="0" width="1" height="1" fill="rgba(246, 161, 212, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(246, 161, 212, 255)" />
<rect x="13" y="1" width="1" height="1" fill="rgba(246, 161, 212, 255)" />
<rect x="14" y="1" width="1" height="1" fill="rgba(246, 161, 212, 255)" />
<rect x="3" y="2" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(246, 161, 212, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(249, 169, 217, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(129, 154, 31, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(249, 169, 217, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(249, 169, 217, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(246, 161, 212, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(252, 203, 231, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(252, 203, 231, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(148, 175, 37, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(129, 154, 31, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(249, 169, 217, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(249, 169, 217, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(229, 99, 163, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(252, 203, 231, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(252, 203, 231, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(202, 195, 161, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(252, 203, 231, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(252, 203, 231, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(252, 203, 231, 255)" />
<rect x="0" y="7" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="1" y="7" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(252, 203, 231, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(243, 150, 205, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(129, 154, 31, 255)" />
<rect x="14" y="7" width="1" height="1" fill="rgba(238, 104, 170, 255)" />
<rect x="0" y="8" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="1" y="8" width="1" height="1" fill="rgba(252, 203, 231, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(229, 99, 163, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(252, 203, 231, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(148, 175, 37, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(238, 104, 170, 255)" />
<rect x="14" y="8" width="1" height="1" fill="rgba(238, 104, 170, 255)" />
<rect x="15" y="8" width="1" height="1" fill="rgba(238, 104, 170, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(245, 218, 239, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(148, 175, 37, 255)" />
<rect x="14" y="9" width="1" height="1" fill="rgba(238, 104, 170, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(129, 154, 31, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(129, 154, 31, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(148, 175, 37, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="14" y="11" width="1" height="1" fill="rgba(148, 175, 37, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(148, 175, 37, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(243, 150, 205, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(249, 169, 217, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(243, 150, 205, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(247, 185, 220, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(243, 150, 205, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(249, 169, 217, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(249, 169, 217, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(129, 154, 31, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(148, 175, 37, 255)" />
</svg>);
export default MinecraftPinkPetals;